export { MARKET_FALLBACK_IMAGE } from '@/constants/brand';

/**
 * Fix image URLs that use /uploads/ path to use /api/uploads/
 * so they route correctly through Kubernetes ingress.
 */
export const fixImageUrl = (url) => {
  if (!url || typeof url !== 'string') return url;
  if (url.startsWith('/uploads/')) return url.replace('/uploads/', '/api/uploads/');
  return url;
};

/**
 * XML import hatalı kayıtlar: "https://algit.com.tr/['https:/cdn.../a.png', ...]"
 * veya ham liste string'inden ilk geçerli görsel URL'sini çıkarır.
 */
export const extractFirstImageUrl = (raw) => {
  if (!raw) return '';
  if (Array.isArray(raw)) {
    for (const item of raw) {
      const u = extractFirstImageUrl(item);
      if (u) return u;
    }
    return '';
  }
  if (typeof raw !== 'string') return '';
  let t = raw.trim();
  if (!t) return '';

  // https:/host → https://host
  t = t.replace(/^(https?):\/([^/])/i, '$1://$2');

  // Liste string'i veya algit.com.tr/[...] sarmalı
  const bracket = t.indexOf('[');
  if (bracket !== -1 && t.includes('http')) {
    const fromList = t.slice(bracket);
    const matches = fromList.match(/https?:\/+[^'"\s,\]]+/gi) || [];
    if (matches.length) {
      return matches[0].replace(/^(https?):\/([^/])/i, '$1://$2');
    }
  }

  // Geçersiz: host + liste birleşimi
  if (/https?:\/\/[^/]+\/\[/i.test(t)) {
    const matches = t.match(/https?:\/+[^'"\s,\]]+/gi) || [];
    const real = matches.find((m) => !/\/\[/.test(m) && !m.includes("['"));
    if (real) return real.replace(/^(https?):\/([^/])/i, '$1://$2');
  }

  return t;
};

/** Boş/geçersiz URL kontrolü; ürün için gösterilecek ham URL döner. */
export const normalizeProductImageSrc = (url) => {
  const extracted = extractFirstImageUrl(url);
  if (!extracted) return '';
  return fixImageUrl(extracted);
};
